define.alias("ember-math-helpers/helpers/random", "settings/helpers/random");